export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "checkImageBitmap.worker.b96b7d2aa5251c257119.worker.js");
}
